/**
 * Sub-services "Why this platform": vertical nav tabs.
 */
document.addEventListener('DOMContentLoaded', function () {
    var navItems = document.querySelectorAll('.subservices-why-nav__item');
    var panels = document.querySelectorAll('.subservices-why-panel');

    navItems.forEach(function (item) {
        item.addEventListener('click', function () {
            navItems.forEach(function (i) { i.classList.remove('is-active'); });
            panels.forEach(function (p) { p.classList.remove('is-active'); });

            this.classList.add('is-active');
            var activePanel = document.querySelector(this.getAttribute('data-tab-target'));
            if (activePanel) activePanel.classList.add('is-active');
        });
    });
});
